import React, { useEffect, Suspense, lazy, createElement } from 'react';
import { Hero } from './components/Hero';
const StatsAndTestimonials = lazy(() => import('./components/StatsAndTestimonials').then(m => ({
  default: m.StatsAndTestimonials
})));
const PainPoints = lazy(() => import('./components/PainPoints').then(m => ({
  default: m.PainPoints
})));
const Modules = lazy(() => import('./components/Modules').then(m => ({
  default: m.Modules
})));
const Bonuses = lazy(() => import('./components/Bonuses').then(m => ({
  default: m.Bonuses
})));
const IsForYou = lazy(() => import('./components/IsForYou').then(m => ({
  default: m.IsForYou
})));
const Pricing = lazy(() => import('./components/Pricing').then(m => ({
  default: m.Pricing
})));
const CostComparison = lazy(() => import('./components/CostComparison').then(m => ({
  default: m.CostComparison
})));
const FinalCTA = lazy(() => import('./components/FinalCTA').then(m => ({
  default: m.FinalCTA
})));
const Footer = lazy(() => import('./components/Footer').then(m => ({
  default: m.Footer
})));
const PurchaseToast = lazy(() => import('./components/PurchaseToast').then(m => ({
  default: m.PurchaseToast
})));
const HERO_IMAGE_URL = 'https://cdn.magicpatterns.com/uploads/84g57gk8zvCpqt2fzfEcbE/DIGITAL-EBOOK-DISENOS-TECNICAS-AVANZADAS-_1_.webp';
const META_PIXEL_ID = '904978025482552';
export function App() {
  useEffect(() => {
    document.documentElement.lang = 'es-AR';
    document.title = 'MegaPack Herrería Blindada™ — Todo tu taller de herrería listo. Desde hoy.';
    // Meta Pixel initialization
    if (typeof window !== 'undefined' && !(window as any).fbq) {
      const f: any = window;
      const b: any = document;
      const v = 'https://connect.facebook.net/en_US/fbevents.js';
      const n: any = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      f.fbq = n;
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = !0;
      n.version = '2.0';
      n.queue = [];
      const t = b.createElement('script') as HTMLScriptElement;
      t.async = true;
      t.src = v;
      const firstScript = b.getElementsByTagName('script')[0];
      if (firstScript && firstScript.parentNode) {
        firstScript.parentNode.insertBefore(t, firstScript);
      } else {
        ;
        (b.head || b.documentElement).appendChild(t);
      }
      ;
      (window as any).fbq('init', META_PIXEL_ID);
      (window as any).fbq('track', 'PageView');
      // noscript fallback
      if (!document.getElementById('fb-pixel-noscript')) {
        const noscript = document.createElement('noscript');
        noscript.id = 'fb-pixel-noscript';
        const img = document.createElement('img');
        img.height = 1;
        img.width = 1;
        img.style.display = 'none';
        img.src = `https://www.facebook.com/tr?id=${META_PIXEL_ID}&ev=PageView&noscript=1`;
        noscript.appendChild(img);
        document.body.appendChild(noscript);
      }
    }
    const preconnects = [{
      href: 'https://cdn.magicpatterns.com',
      crossorigin: false
    }, {
      href: 'https://fonts.googleapis.com',
      crossorigin: false
    }, {
      href: 'https://fonts.gstatic.com',
      crossorigin: true
    }];
    const preconnectElements: HTMLLinkElement[] = [];
    preconnects.forEach(({
      href,
      crossorigin
    }) => {
      if (!document.querySelector(`link[rel="preconnect"][href="${href}"]`)) {
        const link = document.createElement('link');
        link.rel = 'preconnect';
        link.href = href;
        if (crossorigin) link.crossOrigin = '';
        document.head.insertBefore(link, document.head.firstChild);
        preconnectElements.push(link);
      }
    });
    let heroPreloadLink: HTMLLinkElement | null = null;
    if (!document.querySelector(`link[rel="preload"][href="${HERO_IMAGE_URL}"]`)) {
      heroPreloadLink = document.createElement('link');
      heroPreloadLink.rel = 'preload';
      heroPreloadLink.as = 'image';
      heroPreloadLink.href = HERO_IMAGE_URL;
      // @ts-ignore
      heroPreloadLink.fetchPriority = 'high';
      document.head.insertBefore(heroPreloadLink, document.head.firstChild);
    }
    const fontsUrl = 'https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&family=Oswald:wght@500;600;700&display=swap';
    const existingFontLink = document.querySelector(`link[href="${fontsUrl}"]`);
    let fontLink: HTMLLinkElement | null = null;
    if (!existingFontLink) {
      const preloadLink = document.createElement('link');
      preloadLink.rel = 'preload';
      preloadLink.as = 'style';
      preloadLink.href = fontsUrl;
      document.head.appendChild(preloadLink);
      fontLink = document.createElement('link');
      fontLink.rel = 'stylesheet';
      fontLink.href = fontsUrl;
      fontLink.media = 'print';
      fontLink.onload = function () {
        ;
        (this as HTMLLinkElement).media = 'all';
      };
      document.head.appendChild(fontLink);
    }
    const metaDesc = document.querySelector('meta[name="description"]') || document.createElement('meta');
    metaDesc.setAttribute('name', 'description');
    metaDesc.setAttribute('content', 'MegaPack Herrería Blindada: El sistema N°1 para herreros y dueños de taller en Argentina. Costos, presupuestos, planos y blindaje anti-inflación.');
    if (!document.querySelector('meta[name="description"]')) document.head.appendChild(metaDesc);
    if (!document.querySelector('meta[name="viewport"]')) {
      const viewport = document.createElement('meta');
      viewport.setAttribute('name', 'viewport');
      viewport.setAttribute('content', 'width=device-width, initial-scale=1');
      document.head.appendChild(viewport);
    }
    return () => {
      preconnectElements.forEach(el => el.remove());
      if (fontLink) fontLink.remove();
      if (heroPreloadLink) heroPreloadLink.remove();
    };
  }, []);
  return <div className="min-h-screen bg-background text-gray-300 font-body selection:bg-gold selection:text-background" data-id="element-0">
      <a href="#main-content" className="sr-only focus:not-sr-only focus:absolute focus:top-4 focus:left-4 focus:z-50 focus:bg-gold focus:text-background focus:px-4 focus:py-2 focus:rounded-lg focus:font-bold" data-id="element-1">
        Saltar al contenido principal
      </a>
      <main id="main-content" data-id="element-2">
        <Hero data-id="element-3" />
        <Suspense fallback={null} data-id="element-4">
          <StatsAndTestimonials data-id="element-5" />
          <PainPoints data-id="element-6" />
          <Modules data-id="element-7" />
          <Bonuses data-id="element-8" />
          <IsForYou data-id="element-9" />
          <Pricing data-id="element-10" />
          <CostComparison data-id="element-11" />
          <FinalCTA data-id="element-12" />
        </Suspense>
      </main>
      <Suspense fallback={null} data-id="element-13">
        <Footer data-id="element-14" />
        <PurchaseToast data-id="element-15" />
      </Suspense>
    </div>;
}